import React from 'react';
import './index.scss';

function PrivacyPolicy() {
  return (
    <div className="agreement-container" component-data="privacy-policy">
      <div className="agreement-wrap">
        <h1 className="agreement-title">个人信息保护政策</h1>

        <p className="section-content intro">
          欢迎您使用我们的产品和服务！我们非常重视您的隐私保护和个人信息保护。
        </p>

        <section className="agreement-section">
          <h2 className="section-title">一、引言</h2>
          <p className="section-content">
            为了切实保护聘准准用户隐私权，优化用户体验，聘准准根据现行法规及政策，制定本《个人信息保护政策》。本《个人信息保护政策》将详细说明聘准准在获取、管理及保护用户个人信息方面的政策及措施。本《个人信息保护政策》适用于聘准准网站及公司向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得的聘准准服务。
          </p>
          <p className="section-content">
            本《个人信息保护政策》旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么以及如何保护这些数据。我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息。为了向您和其他用户提供更好的服务，我们仅收集必要的信息。
          </p>
          <p className="section-content highlight">
            【特别提示】请您仔细阅读我们的《个人信息保护政策》（尤其是加粗划线的内容），我们希望您在使用聘准准服务前仔细阅读并明确您已经充分理解、接受本《个人信息保护政策》的内容，希望您可以根据自己的理解做出合适的选择。您一旦开始使用聘准准平台服务，即表示您认同本《个人信息保护政策》中所述内容。在我们更新本《个人信息保护政策》后，您继续使用我们的产品与/或服务，即意味着您同意本《个人信息保护政策》(含更新版本)内容，并且同意我们按照本《个人信息保护政策》收集、使用、保存和共享您的相关信息。此外，当我们将您的个人信息用于本《个人信息保护政策》未涵盖的用途时，我们会事先征求您的同意。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">二、我们如何收集和使用您的个人信息</h2>

          <h3 className="sub-title">（一）主要功能及相关个人信息</h3>
          <p className="section-content">
            在您使用聘准准提供的以下服务或功能过程中，我们根据合法、正当、必要、透明的原则，基于本政策所述目的，聘准准会根据具体场景请求您提供对应的个人信息，该信息主要为您根据自己的意愿自行填写的个人信息，我们会严格依法保护您的个人信息。
          </p>

          <h4 className="sub-sub-title">1. 验证成为注册用户</h4>
          <p className="section-content">
            您需要提供注册聘准准用户的手机号码，通过手机号码接收验证码注册登录，我们将通过发送短信验证码的方式来验证您的身份是否有效。
          </p>

          <h4 className="sub-sub-title">2. 实名认证</h4>
          <p className="section-content">
            为确保职位发布者身份的真实性和完成实名认证的要求，聘准准小程序端将进行实名认证，您需要提供实名认证所需必要信息，包括提供真实姓名、性别、年龄、身份证号。
          </p>

          <h4 className="sub-sub-title">3. 使用招聘服务</h4>
          <p className="section-content">
            基于保护求职者安全，当您使用聘准准小程序时，我们在首次会通过弹窗申请获取您的位置信息（GPS定位）；经您授权同意后，再获取您的位置权限，包括您所在的城市、地区。我们承诺仅收集您当时所处位置信息，不会追踪您的行踪轨迹。如果拒绝授权，您仍可继续使用聘准准的其他求职功能。
          </p>

          <h4 className="sub-sub-title">4. 创建在线简历</h4>
          <p className="section-content">
            创建在线简历时，会设置您的头像、填写生日、年龄、住址、期望工作地、工作经验、自我介绍、职业技能等基本简历信息。聘准准将根据您的以上信息，为您展示合适的岗位。
          </p>
          <p className="section-content">
            <strong>提示您注意，如果您为求职者用户，我们将在以下场景使用您的个人信息：</strong>
          </p>
          <ul className="content-list">
            <li>当您填写简历之后可以选择将简历向招聘方投递，或者选择与平台内招聘者用户进行沟通主动向其投递您的个人简历，您的简历信息将通过平台传递至招聘者用户。如您的简历投递成功，您简历投向的招聘者用户在登录到系统或将简历下载到其设备终端本地后可看到您的全名和联系方式，以便直接对您发出工作邀请。请您注意，简历投递成功后不支持撤回。因此，在投递简历前，请仔细核对简历内容，确保信息准确无误。</li>
            <li>招聘者用户可以对您的简历信息进行查询、浏览，且您的简历及其他个人信息会显示给招聘者用户。</li>
            <li>为便于招聘者用户在本平台上与求职者用户进行沟通以达到双方需求的对接，我们会将您的联系方式提供给招聘者用户。</li>
            <li>除上述情形外，我们不会在未经您同意的情况下向任何第三方共享您的简历信息。</li>
          </ul>

          <h4 className="sub-sub-title">5. 搜索职位/简历信息</h4>
          <p className="section-content">
            您可以通过聘准准软件内的搜索功能，尽可能精准地为您提供满足需求或符合偏好的信息。我们会保留您的关键词搜索记录或基于您的使用习惯，避免您再重复输入或为您展示与您搜索内容相关老板或求职用户。
          </p>

          <h4 className="sub-sub-title">6. 拨打电话</h4>
          <p className="section-content">
            当您发布简历或者发布职位后我们会将您的电话给到想要联系您的用户，如果您不希望其他人再联系您，您可以删除掉简历信息或职位信息，或者联系我们删除。
          </p>

          <h4 className="sub-sub-title">7. 拨打客服和售后服务</h4>
          <p className="section-content">
            当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录，以及使用您的账号信息以便核验身份；当您需要我们提供与您使用相关的客户服务时，我们可能会查询您的相关使用信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息（如联系方式、简历信息、岗位信息）时，您可能还需要提供上述信息外的其他信息以便完成修改。
          </p>

          <h3 className="sub-title">（二）改进产品和保障求职用户安全的相关信息</h3>
          <p className="section-content">
            为了增强聘准准平台的求职招聘过程中的安全性，尽可能保障您或其他用户在招聘求职过程中的人身、财产安全免遭侵害，我们会收集必要的不涉及到您的个人身份隐私的信息，包括：
          </p>
          <p className="section-content">
            我们可能会收集您网络服务相关的日志信息，包括IP地址、某按钮的点击使用时间和频率、某页面的使用时间和频率、某些关键配置的选项值、崩溃日志、错误日志，用于将您感兴趣的职位、简历或求职过程中您可能需要的服务信息展示给您，同时有可能用于统计我们产品的用户数量、分析产品的使用状况、网页升级改版、浏览器兼容性检测、排查崩溃原因、减少崩溃情况。
          </p>

          <h3 className="sub-title">（三）需要您授权同意调取系统权限的情形</h3>
          <p className="section-content">
            基于保护求职招聘过程中的求职者人身安全之考虑，以及满足互联网平台服务普遍存在的风控需求，聘准准的业务功能可能需要您先同意我们调取相关的系统权限以使用您的个人信息。您可通过小程序上的"设置-权限管理"逐项查看具体的个人信息访问权限及其开启状态，并决定开启或关闭这些权限。若开启这些权限即代表您授权我们收集和使用这些个人信息：
          </p>

          <h4 className="sub-sub-title">聘准准小程序申请使用权限列表</h4>
          <div className="table-wrapper">
            <table className="permission-table">
              <thead>
                <tr>
                  <th>权限名称</th>
                  <th>权限功能说明</th>
                  <th>使用场景或目的</th>
                  <th>可否关闭</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>获取设备权限</td>
                  <td>提供读取手机设备标识信息，请您放心该权限无法监听、获取您的任何通话内容与信息</td>
                  <td>当您运行聘准准小程序时，我们会向您申请获取此权限，目的是正常识别您的本机识别码，以便完成安全风控、进行统计和服务推送，如您拒绝您可选择关闭此权限。</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>读取外置存储器</td>
                  <td>提供读取手机储存空间内数据的功能</td>
                  <td>允许小程序读取存储中的图片、文件内容，主要用于帮助您发布信息，在本地记录崩溃日志信息（如有）功能</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>写入外置存储器</td>
                  <td>提供写入外部储存功能</td>
                  <td>允许小程序写入/下载/保存/修改/删除图片、文件、崩溃日志信息</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>访问相册权限</td>
                  <td>用于支持存储中图片和视频的访问、发送、上传</td>
                  <td>用于您设备上的相册上传头像、在发布的信息中添加图片、在帮助与反馈页面上传图片，并收集您设备上的图片或视频。当您同意开启此项权限后，可以将相册中的图片用于简历，如果拒绝开启此权限，前述功能将无法正常使用，但不会影响您正常使用其他功能。</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>访问相机权限</td>
                  <td>拍摄照片和视频、扫描二维码</td>
                  <td>用于二维码扫描、拍摄并上传照片/视频、开展身份认证。</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>访问精准定位</td>
                  <td>通过全球定位系统（GPS）或网络位置信息（如基站和WLAN）获取精准地理位置信息</td>
                  <td>用于您的位置信息来实现"查找附近职位"的业务功能，保障用户身份和职位信息真实有效，确保求职安全，但我们承诺仅收集您所处的位置信息，如您所在的省、市、区（县），而不会追踪您的行踪轨迹。如果拒绝开启位置信息，您仍可使用其他找工作业务功能。</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>获取剪切板</td>
                  <td>读取您的剪切板内容</td>
                  <td>将剪切板的内容作为简历详情或岗位详情，快速发布简历信息。</td>
                  <td>是</td>
                </tr>
                <tr>
                  <td>获取软件安装列表</td>
                  <td>让您能够正常分享到微信</td>
                  <td>方便您能够正常分享到微信。</td>
                  <td>是</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="sub-title">（四）通过微信SDK收集信息的情形</h3>
          <p className="section-content">
            聘准准小程序的部分业务服务或功能，需要使用微信SDK来协助完成。目前使用的SDK包括：
          </p>
          <div className="table-wrapper">
            <table className="permission-table">
              <thead>
                <tr>
                  <th>第三方公司</th>
                  <th>服务名称</th>
                  <th>使用目的/场景</th>
                  <th>信息类型</th>
                  <th>共享方式</th>
                  <th>第三方隐私政策链接</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>深圳市腾讯计算机系统有限公司</td>
                  <td>微信 SDK</td>
                  <td>用于帮助用户将内容分享至微信、支持微信支付</td>
                  <td>网络状态、WIFI状态、手机状态、设备版本、系统版本、生成ID、手机样式、手机名、ICCID、BSSID、IMSI、IMEI、获取安装的应用信息</td>
                  <td>SDK自动收集</td>
                  <td><a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" target="_blank" rel="noopener noreferrer">查看</a></td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="sub-title">（五）征得授权同意的例外</h3>
          <p className="section-content">
            根据相关法律法规的规定，在以下情形中，我们可以在不征得您的授权同意的情况下收集、使用一些必要的个人信息：
          </p>
          <ul className="content-list">
            <li>与履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
            <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
            <li>所收集的个人信息是您自行向社会公众公开的；</li>
            <li>从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；</li>
            <li>根据您的要求签订和履行合同所必需的；</li>
            <li>学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</li>
            <li>用于维护聘准准平台产品和/或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；</li>
            <li>法律法规规定的其他情形；</li>
          </ul>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">三、我们如何使用Cookie和同类技术</h2>
          <p className="section-content">
            为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 cookie 的小数据文件。cookie 通常包含用户身份标识符、城市名称以及一些字符。cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用cookie技术，我们能够为您提供更加周到的服务。 我们不会将 cookie 用于本《个人信息保护政策》所述目的之外的任何用途。您可根据自己的偏好管理或删除 cookie。您可以清除计算机上保存的所有 cookie，大部分网络浏览器都设有阻止 cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，但您可能因为该修改，无法登录或使用依赖于cookie的服务或功能。 您可以通过更改您的浏览器设置限制聘准准对cookie的使用。以chrome浏览器为例，您可以在chrome浏览器右上方的下拉菜单的"浏览器设置"中，通过"设置-高级-清除浏览数据"，选择清除您的cookie。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">四、我们如何共享、转让或公开披露您的个人信息</h2>

          <h3 className="sub-title">（一）共享</h3>
          <p className="section-content">
            除以下情形外，未经您同意，我们不会向除聘准准平台的运营主体及其关联公司以外的任何第三方公司、组织和个人分享您的信息。
          </p>
          <p className="section-content">
            <strong>关联平台之间的信息共享：</strong>
          </p>
          <p className="section-content">
            您可以通过统一的聘准准账号登录并使用我们运营的其他产品或服务。当您登录我们的服务时，聘准准可能与我们运营的聘准准任务管理平台、零工任务接单平台（"关联平台"）共享您的个人信息（包括个人敏感信息），实际操作中还应征询您的单独同意。以便更好地统一管理您在各关联平台的信息，以及保障您在关联平台公开展示信息的一致性。共享信息包括：
          </p>
          <ul className="content-list">
            <li>账号信息（昵称、头像、出生年月、性别、微信号、手机号）</li>
            <li>个人信息类型包括：招聘者（求职者）的头像、昵称、岗位信息（简历信息）、性别、手机号。</li>
          </ul>

          <h3 className="sub-title">（二）转让</h3>
          <p className="section-content">
            我们不会将您的个人信息转让给除聘准准平台的运营主体及其关联公司以外的任何公司、组织和个人，但以下情形除外：
          </p>
          <ul className="content-list">
            <li>事先获得您的明确授权或同意；</li>
            <li>满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；</li>
            <li>如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
          </ul>

          <h3 className="sub-title">（三）公开披露</h3>
          <p className="section-content">
            我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示我们的产品或服务的整体使用趋势。请您放心，这些统计信息不包含您的任何身份识别信息。我们仅会在以下情形下，公开披露您的个人信息：
          </p>
          <ul className="content-list">
            <li>获得您的明确同意；</li>
            <li>基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</li>
          </ul>

          <h3 className="sub-title">（四）例外情形</h3>
          <p className="section-content">
            在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
          </p>
          <ul className="content-list">
            <li>与我们履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
            <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
            <li>您自行向社会公众公开的个人信息；</li>
            <li>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
            <li>根据个人信息主体要求签订和履行合同所必需的；</li>
            <li>用于维护所提供的产品或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；</li>
            <li>法律法规规定的其他情形。</li>
          </ul>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">五、我们如何保存及保护您的个人信息</h2>

          <h3 className="sub-title">（一）保存信息</h3>
          <h4 className="sub-sub-title">1. 信息存储</h4>
          <p className="section-content">
            您在使用聘准准产品及服务期间，我们将依据《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》等相关法律法规的规定保存您的信息。在您注销账户或主动删除上述信息后，我们将同步删除您的个人信息，但我们可能会对您的个人信息进行去除个人特征的匿名化处理后用于数据统计的合法目的。
          </p>

          <h4 className="sub-sub-title">2. 保存地域</h4>
          <p className="section-content">
            您的个人信息均储存于中华人民共和国境内。
          </p>

          <h4 className="sub-sub-title">3. 例外情况</h4>
          <p className="section-content">
            一般而言，我们仅为实现目的所必需的合理时间保留您的个人信息，下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：
          </p>
          <ul className="content-list">
            <li>为遵守法律法规等有关规定的适用；</li>
            <li>为遵守法院判决、裁定或其他法律程序的规定；</li>
            <li>为遵守相关政府机关或法定授权组织的要求；</li>
            <li>我们有理由确信需要遵守法律法规等有关规定；</li>
            <li>为执行相关服务协议或本《个人信息保护政策》维护社会公共利益；</li>
            <li>为保护我们及我们的客户、用户或雇员的人身财产安全；</li>
            <li>其他合法权益所合理必需的用途。</li>
          </ul>
          <p className="section-content">
            当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
          </p>

          <h3 className="sub-title">（二）保护措施</h3>
          <p className="section-content">
            我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对聘准准网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全培训课程，加强员工对于保护个人信息重要性的认识。
          </p>
          <p className="section-content">
            我们从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
          </p>
          <p className="section-content">
            我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本《个人信息保护政策》所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求）。
          </p>

          <h3 className="sub-title">（三）安全事件通知</h3>
          <p className="section-content">
            我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。
          </p>
          <p className="section-content">
            个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，由相关部门组成应急响应小组，在最短时间内追溯原因并减少损失。
          </p>
          <p className="section-content">
            在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时通过软件内部提醒、短信或电话等方式向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况通过上述方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">六、您的权利</h2>
          <p className="section-content">
            按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
          </p>

          <h3 className="sub-title">（一）访问和修改您的个人信息</h3>
          <p className="section-content">
            您可以随时修改您的简历信息。
          </p>

          <h3 className="sub-title">（二）删除您的个人信息</h3>
          <p className="section-content">
            在以下情形中，您可以向我们提出删除个人信息的请求，您可以通过客户服务联系方式随时与我们联系：
          </p>
          <ul className="content-list">
            <li>如果我们违反法律法规或与您的约定收集、使用、与第三方共享或转让您的个人信息；</li>
            <li>如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息。</li>
            <li>我们没有征求您的明确同意，收集了您的个人信息。</li>
            <li>我们违反了与您的约定来使用和处理您的个人信息。</li>
            <li>您注销了聘准准账号，或者不再使用我们的产品（或服务）。</li>
            <li>我们停止对您提供服务。</li>
          </ul>

          <h3 className="sub-title">（三）改变授权范围</h3>
          <p className="section-content">
            <strong>1、改变或撤回敏感信息权限</strong>
          </p>
          <p className="section-content">
            您可以在设备本身操作系统中关闭地理位置、摄像头、麦克风权限改变同意范围或撤回您的授权。
          </p>
          <p className="section-content">
            <strong>2、请您理解，</strong>特定的业务功能和服务将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">七、我们如何处理未成年人的个人信息</h2>
          <p className="section-content">
            聘准准非常重视对未成年人信息的保护。基于我们的产品、网站和服务的性质，我们仅面向成年人提供服务（原则上18周岁以上为成年人，16周岁以上且以自己的劳动收入为主要生活来源的我们亦视为具有服务使用资格）。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">八、本《个人信息保护政策》的更新</h2>
          <p className="section-content">
            我们可能适时修订本《个人信息保护政策》内容。如该等变更会导致您在本《个人信息保护政策》项下权利的实质变化，若您不同意该等变更应停止使用聘准准平台产品和服务，请及时联系我们暂时封停您的账号。若您继续使用我们的产品或服务，即表示您同意受修订后的本《个人信息保护政策》的约束；
          </p>
          <p className="section-content">
            若涉及重大、实质性变更，我们会依据具体情况，以弹窗提示等显著的方式通知您。本《个人信息保护政策》所指的重大变更包括但不限于：
          </p>
          <ul className="content-list">
            <li>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
            <li>个人信息共享、转让或公开披露的主要对象发生变化；</li>
            <li>您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
            <li>其他可能对您的个人信息权益产生重大影响的变化时；</li>
            <li>个人信息出境情况发生变更时；</li>
            <li>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等。</li>
          </ul>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">九、争议解决</h2>
          <p className="section-content">
            本《个人信息保护政策》与《聘准准用户协议》共同构成您使用聘准准服务的基本协议文件。本《个人信息保护政策》适用中华人民共和国现行法律法规。与本《个人信息保护政策》相关的争议，如果您对我们的回复或解决方案不满意，需要通过法律途径解决的，您在此同意将该争议提交至杭州仲裁委员会，其仲裁裁决是终局的。
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;